import inputKey from './inputKey'
const openSites = new Map(
  [
    [inputKey.baidu, "https://www.baidu.com/"]
    ,[inputKey.ecosia, "https://www.ecosia.org/"]
    ,[inputKey.google, "https://www.google.com/"]
    ,[inputKey.yahoo, "https://www.yahoo.com/"]
    ,[inputKey.bing, "https://www.bing.com/"]
    ,[inputKey.qihu, "https://www.so.com/"]
    ,[inputKey.sougou, "https://www.sogou.com/"]
    ,[inputKey.soso, "http://www.soso.com/"]
    ,[inputKey.youku, "https://www.youku.com/"]
    ,[inputKey.tudou, "http://www.tudou.com/"]
    ,[inputKey.qqVideo, "https://v.qq.com/"]
    ,[inputKey.iqiyi, "https://www.iqiyi.com/"]
    ,[inputKey.bilibili, "https://www.bilibili.com/"]
    ,[inputKey.mgtv, "https://www.mgtv.com/"]
    ,[inputKey.sohutv, "https://tv.sohu.com/"]
    ,[inputKey.le, "http://www.le.com/"]
    ,[inputKey.acfun, "http://www.acfun.cn/"]
    ,[inputKey.nico, "http://www.nicovideo.jp/"]
    ,[inputKey.youtube, "https://www.youtube.com/"]
    ,[inputKey.qqmusic, "https://y.qq.com/"]
    ,[inputKey.xiamimusic, "https://www.xiami.com/"]
    ,[inputKey.netmusic, "https://music.163.com/"]
    ,[inputKey.kugoumusic, "http://www.kugou.com/"]
    ,[inputKey.youtubemusic, "https://music.youtube.com/"]
    ,[inputKey.baidumusic, "http://music.taihe.com/"]
    ,[inputKey.yinyuetai, "http://www.yinyuetai.com/"]
    ,[inputKey.qqmusicmv, "https://y.qq.com/portal/mv_lib.html"]
    ,[inputKey.zhihu, "https://www.zhihu.com/"]
    ,[inputKey.baiduzhidao, "https://zhidao.baidu.com/"]
    ,[inputKey.baidubaike, "https://baike.baidu.com/"]
    ,[inputKey.sougoubaike, "https://baike.sogou.com/"]
    ,[inputKey.qihubaike, "https://baike.so.com/"]
    ,[inputKey.hudongbaike, "http://www.baike.com/"]
    ,[inputKey.wikibaike, "https://zh.wikipedia.org/zh-hans/"]
    ,[inputKey.baiduxinwen, "http://news.baidu.com/"]
    ,[inputKey.qqxinwen, "http://news.qq.com/"]
    ,[inputKey.netxinwen, "https://news.163.com/"]
    ,[inputKey.sohuxinwen, "http://news.sohu.com/"]
    ,[inputKey.sinaxinwen, "http://news.sina.com.cn/"]
    ,[inputKey.taobao, "https://www.taobao.com/"]
    ,[inputKey.jd, "https://www.jd.com/"]
    ,[inputKey.tmall, "https://www.tmall.com/"]
    ,[inputKey.amazoncn, "https://www.amazon.cn/"]
    ,[inputKey.amazon, "https://www.amazon.com/"]
    ,[inputKey.github, "https://github.com/"]
    ,[inputKey.oschina, "https://www.oschina.net/"]
    ,[inputKey.segmentfault, "https://segmentfault.com/"]
    ,[inputKey.stackoverflow, "https://stackoverflow.com/"]
    ,[inputKey.qq, "http://www.qq.com/"]
    ,[inputKey.hao123, "https://www.hao123.com/"]
    ,[inputKey.sohu, "http://www.sohu.com/"]
    ,[inputKey.sina, "https://www.sina.com.cn/"]
    ,[inputKey.googletranslate, "https://translate.google.cn/"]
    ,[inputKey.baiduwenku, "https://wenku.baidu.com/"]
    ,[inputKey.baiduwangpan, "https://pan.baidu.com/"]
    ,[inputKey.xinhuawang, "http://www.xinhuanet.com/"]
    ,[inputKey.yaoyaowu, "https://115.com/"]
    ,[inputKey.sinablog, "http://blog.sina.com.cn/"]
    ,[inputKey.renminribao, "http://people.com.cn/"]
    ,[inputKey.gmw, "http://www.gmw.cn/"]
    ,[inputKey.tianya, "http://www.tianya.cn/"]
    ,[inputKey.youth, "https://www.youth.cn/"]
    ,[inputKey.china, "https://www.china.com/index.html"]
    ,[inputKey.cctv, "http://www.cctv.com/"]
    ,[inputKey.alipay, "https://www.alipay.com/"]
    ,[inputKey.babytree, "http://www.babytree.com/"]
    ,[inputKey.huanqiu, "http://www.huanqiu.com/"]
    ,[inputKey.csdn, "https://www.csdn.net/"]
    ,[inputKey.mamawang, "http://www.mama.cn/"]
    ,[inputKey.zol, "http://www.zol.com.cn/"]
    ,[inputKey.net163, "https://www.163.com/"]
    ,[inputKey.douyu, "https://www.douyu.com/"]
    ,[inputKey.bitauto, "http://www.bitauto.com/"]
    ,[inputKey.douban, "https://www.douban.com/"]
    ,[inputKey.caijing, "http://www.caijing.com.cn/"]
    ,[inputKey.yesky, "http://www.yesky.com/"]
    ,[inputKey.dianying1905, "http://www.1905.com/"]
    ,[inputKey.cnnic, "https://www.cnnic.net.cn/"]
    ,[inputKey.cnblogs, "https://www.cnblogs.com/"]
    ,[inputKey.zhongguoribao, "http://cn.chinadaily.com.cn/"]
    ,[inputKey.alibaba, "https://www.alibaba.com/"]
    ,[inputKey.apple, "https://www.apple.com/"]
    ,[inputKey.facebook, "https://www.facebook.com/"]
    ,[inputKey.microsoft, "https://www.microsoft.com/"]
    ,[inputKey.dongfangwang, "http://www.eastday.com/"]
    ,[inputKey.chaoshitmall, "https://chaoshi.tmall.com/"]
    ,[inputKey.youdaonote, "https://note.youdao.com/"]
    ,[inputKey.hongwang, "http://www.rednet.cn/index.html"]
    ,[inputKey.instagram, "https://www.instagram.com/"]
    ,[inputKey.aliyun, "https://www.aliyun.com/"]
    ,[inputKey.chinaz, "http://www.chinaz.com/"]
    ,[inputKey.huaban, "http://huaban.com/"]
    ,[inputKey.ifeng, "http://www.ifeng.com/"]
    ,[inputKey.linkedin, "https://www.linkedin.com/"]
    ,[inputKey.suning, "https://www.suning.com/"]
    ,[inputKey.cnmo, "http://www.cnmo.com/"]
    ,[inputKey.zhanqi, "https://www.zhanqi.tv/"]
    ,[inputKey.k618, "http://www.k618.cn/"]
    ,[inputKey.wuba, "http://www.58.com/"]
    ,[inputKey.stockstar, "http://www.stockstar.com/"]
    ,[inputKey.jb51, "https://www.jb51.net/"]
    ,[inputKey.pk52, "http://www.52pk.com/"]
    ,[inputKey.toutiao, "https://www.toutiao.com/"]
    ,[inputKey.xunlei, "https://www.xunlei.com/"]
    ,[inputKey.bbc, "http://www.bbc.com/"]
    ,[inputKey.twitter, "https://twitter.com/"]
    ,[inputKey.ebay, "https://www.guokr.com/"]
    ,[inputKey.tumblr, "https://www.tumblr.com/"]
    ,[inputKey.mi, "https://www.mi.com/index.html"]
    ,[inputKey.zhaopin, "https://www.zhaopin.com/"]
    ,[inputKey.ly, "https://www.ly.com/"]
    ,[inputKey.jia, "http://www.jia.com/"]
    ,[inputKey.adobe, "https://www.adobe.com/"]
    ,[inputKey.hupu, "https://www.hupu.com/"]
    ,[inputKey.jianshu, "https://www.jianshu.com/"]
    ,[inputKey.mail126, "https://www.126.com/"]
    ,[inputKey.mail163, "https://mail.163.com/"]
    ,[inputKey.sisanjiujiu, "http://www.4399.com/"]
    ,[inputKey.dianping, "https://www.dianping.com/"]
    ,[inputKey.sandm, "https://www.3dmgame.com/"]
    ,[inputKey.gamersky, "http://www.gamersky.com/"]
    ,[inputKey.duba, "http://www.ijinshan.com/"]
    ,[inputKey.panda, "https://www.panda.tv/"]
    ,[inputKey.steampowered, "https://www.steampowered.com/"]
    ,[inputKey.to8to, "http://www.to8to.com/"]
    ,[inputKey.feng, "https://www.feng.com/"]
    ,[inputKey.ngacn, "http://ngacn.cc/"]
    ,[inputKey.yaoqiyaoqisan, "https://www.17173.com/"]
    ,[inputKey.wordpress, "https://wordpress.org/"]
    ,[inputKey.cto51, "http://www.51cto.com/"]
    ,[inputKey.smzdm, "https://www.smzdm.com/"]
    ,[inputKey.w3school, "http://www.w3school.com.cn/"]
    ,[inputKey.w3schools, "https://www.w3schools.com/"]
    ,[inputKey.renren, "http://www.renren.com/"]
    ,[inputKey.v2ex, "https://www.v2ex.com/"]
    ,[inputKey.runoob, "http://www.runoob.com/"]
    ,[inputKey.paypal, "https://www.paypal.com/"]
    ,[inputKey.tieba, "https://tieba.baidu.com/"]
    ,[inputKey.gome, "https://www.gome.com.cn/"]
    ,[inputKey.autohome, "https://www.autohome.com.cn/"]
    ,[inputKey.fang, "http://www1.fang.com/"]
    ,[inputKey.ctrip, "http://www.ctrip.com/"]
    ,[inputKey.yaoersanlingliu, "http://www.12306.cn/"]
    ,[inputKey.guazi, "https://www.guazi.com/"]
    ,[inputKey.qunar, "https://www.qunar.com/"]
    ,[inputKey.booking, "https://www.booking.com/"]
    ,[inputKey.tuniu, "http://www.tuniu.com/"]
    ,[inputKey.mafengwo, "http://www.mafengwo.cn/"]
    ,[inputKey.feizhu, "https://www.alitrip.com/"]
    ,[inputKey.qidian, "https://www.qidian.com/"]
    ,[inputKey.jinjiang, "http://www.jjwxc.net/"]
    ,[inputKey.pconline, "http://www.pconline.com.cn/"]
    ,[inputKey.ithome, "https://www.ithome.com/"]
    ,[inputKey.zealer, "http://www.zealer.com/"]
    ,[inputKey.huya, "https://www.huya.com/"]
    ,[inputKey.longzhu, "http://longzhu.com/"]
    ,[inputKey.ganji, "http://www.ganji.com/"]
    ,[inputKey.baixing, "http://www.baixing.com/"]
    ,[inputKey.beike, "https://www.ke.com/"]
    ,[inputKey.lianjia, "https://www.lianjia.com/"]
    ,[inputKey.woaiwojia, "https://www.5i5j.com/"]
    ,[inputKey.meituan, "http://www.meituan.com/"]
    ,[inputKey.huajun, "http://www.onlinedown.net/"]
    ,[inputKey.qianchengwuyou, "https://www.51job.com/"]
    ,[inputKey.lagou, "https://www.lagou.com/"]
    ,[inputKey.mailqq, "https://mail.qq.com/"]
    ,[inputKey.mailsina, "https://mail.sina.com.cn/"]
    ,[inputKey.xiachufang, "https://www.xiachufang.com/"]
    ,[inputKey.qiushibaike, "https://www.qiushibaike.com/"]
    ,[inputKey.tianyancha, "https://www.tianyancha.com/"]
    ,[inputKey.netstudy, "https://study.163.com/"]
    ,[inputKey.imooc, "https://www.imooc.com/"]
    ,[inputKey.qqweb, "https://web2.qq.com/"]
    ,[inputKey.weixinweb, "https://wx.qq.com/"]
    ,[inputKey.tencentcloud, "https://cloud.tencent.com/"]
    ,[inputKey.aws, "https://aws.amazon.com/"]
    ,[inputKey.azure, "https://azure.microsoft.com/"]
    ,[inputKey.googlecloud, "https://cloud.google.com/"]
    ,[inputKey.anjuke, "https://www.anjuke.com/"]
    ,[inputKey.bcy, "https://bcy.net/"]
    ,[inputKey.guoguo, "https://www.guoguo-app.com/"]
    ,[inputKey.dianxin, "https://www.189.cn/"]
    ,[inputKey.yidong, "http://www.10086.cn/"]
    ,[inputKey.liantong, "http://www.10010.com/"]
    ,[inputKey.gaode, "https://ditu.amap.com/"]
    ,[inputKey.baidumap, "https://map.baidu.com/"]
    ,[inputKey.tencentmap, "https://map.qq.com/"]
    ,[inputKey.googlemap, "https://www.google.com/maps"]
    ,[inputKey.didi, "https://www.didiglobal.com/"]
    ,[inputKey.eleme, "https://www.ele.me/home/"]
    ,[inputKey.meituanwaimai, "http://waimai.meituan.com/"]
    ,[inputKey.koubei, "https://www.koubei.com/"]
    ,[inputKey.gmail, "https://mail.google.com/"]
    ,[inputKey.baidutranslate, "https://fanyi.baidu.com/"]
    ,[inputKey.youdaotranslate, "http://fanyi.youdao.com/"]
    ,[inputKey.ximalaya, "https://www.ximalaya.com/"]
    ,[inputKey.weibo, "https://www.weibo.com/login.php"]
    ,[inputKey.guoke, "https://www.guokr.com/"]
    ,[inputKey.tencentstudy, "https://ke.qq.com/"]
  ]
)
export default openSites



// WEBPACK FOOTER //
// ./src/cnConst/openSites.js